import React, { createContext } from 'react'


const MediaContext = createContext(null)


export default MediaContext
